import { usePathname } from "next/navigation";
import LocationIcon from "components/icons-svg/Location";
import SearchIcon from "components/icons-svg/SearchIcon";
const MobileSearchBoxSkeleton = () => {
  const pathname = usePathname();
  const isVacationRentalPage = pathname?.startsWith("/vacation-rentals");
  return <div className='md:mb-5' data-sentry-component="MobileSearchBoxSkeleton" data-sentry-source-file="MobileSearchBoxSkeleton.tsx">
      <div className='relative flex cursor-pointer items-center'>
        <div className='absolute left-4 flex h-12 items-center text-secondary1000'>
          <LocationIcon className='h-4 w-4' data-sentry-element="LocationIcon" data-sentry-source-file="MobileSearchBoxSkeleton.tsx" />
        </div>
        {/* when user click on input field, it will open search drawer */}
        <input aria-label='search options' name='searchInput' type='search' className={`google-autocomplete-places input h-12 w-full min-w-[125px] cursor-pointer text-ellipsis rounded-[100px] border border-[#0B6F81] py-3 pl-8 pr-11 font-medium text-[#606161] placeholder:text-sm focus-visible:shadow-none focus-visible:outline-0`} placeholder={isVacationRentalPage ? "" : "Start your search..."} readOnly={true} />
        <div className='block'>
          <span className='absolute left-12 top-2 text-sm font-medium leading-3 text-[#131616]'>
            Anywhere
          </span>
          <span className='absolute left-12 text-xs text-[#708487]'>
            Anytime · Add guests
          </span>
        </div>
        {/* Search button to open the search drawer */}
        <button className='btn btn-primary absolute right-2 h-8 min-h-[32px] w-8 min-w-[32px] rounded-full border-none p-2 hover:bg-[#015764]'>
          <SearchIcon className='h-4 w-4 text-white' data-sentry-element="SearchIcon" data-sentry-source-file="MobileSearchBoxSkeleton.tsx" />
        </button>
      </div>
    </div>;
};
export default MobileSearchBoxSkeleton;